const maijia = {
    headText0: "我们更懂你的需求",
    headText1: "品与效，我们更懂你",
    headText2: "数字化营销模式，我们用数据向您证明营销效果",
    headText3: "比传统营销更有价值",
    headText4: "我们坚持品效合一的营销模式",
    headText5: "你距离发现新市场只差一个多麦",
    headText6: "选择我们，你将拥有品牌专属管家",

    serveTitle: "专业服务",
    serveIllustrate: "品牌本土化一站式服务机构，助力品效合一",

    serveTitle1: "内容营销",
    serveDetail1:
        "创意海报、达人种草、开箱视频、淘内营销、趣味条漫、IP合作、直播、热门话题…为品牌定制深洞察、易传播、强互动的创意内容。",
    serveTitle2: "活动Campaign",
    serveDetail2:
        "元旦、CNY、214情人节、38女神节、618、万圣节、感恩节、双十一、圣诞节、黑五等重要营销节点Campain投放，为品牌营造“现象级刷屏",
    serveTitle3: "媒体资源",
    serveDetail3:
        "400+自有KOL，覆盖超过3亿用户；600+深度合作KOL，多家主流媒体独家采购代理权。35W+线上媒体资源库，涵盖领域广，拥有多渠道social资源整合能力。",
    serveTitle4: "效果营销",
    serveDetail4:
        "保底ROI，确保投入产出比，增加预算有效利用率。为品牌提供有效果的营销方案，精准触达潜在消费者，触发购买行为。",
    serveTitle5: "数据支持",
    serveDetail5:
        "自有数据库多维度标记资源，响应各类需求，精准匹配投放资源。系统7*24小时效果监测，科学评估投放结果，并即时进行资源优化。",

    goodCase: "精彩案例",
    knowMore: "了解更多",
    seeMore: "查看更多",

    maijiaTitle: "欢迎走进麦加",
    maijiaText1:
        "麦加广告是中国效果营销的优质服务机构，提供专业的效果营销服务，拥有全国领先的广告监测系统以及全域营销数据系统。",
    maijiaText2: "真实、客观的数据是我们对客户的保证。",
    maijiaText3:
        "合适的方案才是好的方案——经验丰富的营销团队为品牌定制专属营销方案，深度挖掘品牌需求，精确定位用户群体，保证声量的同时提升转化，品效合一是我们的强项，成立至今我们已完成了近百家品牌营销服务。我们是麦加，是你值得信赖的伙伴，选择麦加，就是选择品效合一！",

    contactTitle: "联系我们",
    contactIllustrate: "请联系我们，多麦期待与您合作共同发展",
    submitBtn: "提交",

    contactAdressTitle: "地址：",
    contactAdressDetail: "杭州市江干区普盛巷9号东谷创业园8-9层",
    contactTelTitle: "电话：",
    contactTelDetail: "+86 0571-56638559",
    contactEmailTitle: "邮箱：",
    contactEmailDetail: "kalika@duomai.com",

    contactText1: "联系我们，你将获得",
    contactText2: "专属营销方案",
    contactText3: "定制行销方案",
    contactText4: "全渠道的推广",
    contactText5: "我们将打造您的下一个爆款",
    contactText6: "期待您的联系",

    partnersTitle: "我们的部分合作客户",

    nextPage: "下一页",

    DuoMaiTitle: "关于DUOMAI",
    DuoMaiIllustrate: "品牌营销一站式服务机构，助力品效合一"
};

export { maijia };
